<!-- <app-pias-layout> -->
<div pias-layout-content>
  @if(this.setSprinner()) {
  <div class="pias-spinner">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  }
  <div class="content">
    <div class="new-rep-container">
      <div class="page-header">
        <!-- <div class="header-badge">
      <mat-icon>lock</mat-icon>
      Secure Onboarding
    </div> -->
        <h1 class="page-title">Applicant Onboarding</h1>
        <!-- <p class="page-subtitle">Complete the sections below to submit your professional profile.</p> -->
      </div>

      <mat-accordion [formGroup]="onboardingForm">

        <mat-expansion-panel [expanded]="this.currentStep === 0">

          <mat-expansion-panel-header class="d-flex justify-content-between" (click)="changeIndex(0)">
            <mat-panel-title class="page-header">
              <mat-icon class="header-icon">business</mat-icon>
              Branch Details
            </mat-panel-title>
            @if( this.branchDetailsFormValid() == 'Completed'){
            <span class="status-badge completed m-4">✔ Completed</span>
            }@else if( this.branchDetailsFormValid() == 'In Progress') {
            <span class="status-badge inprogress m-4">⏳ In Progress</span>
            }@else {
            <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon> Not Started</span>
            }
          </mat-expansion-panel-header>

          <app-branch-details [formGroup]="branchDetailsForm" *ngIf="viewApplicationdetails"
            [branchdetails]="viewApplicationdetails" (next)="onSectionNext($event, 0)">
          </app-branch-details>

        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="this.currentStep === 1">

          <mat-expansion-panel-header class="d-flex justify-content-between" (click)="changeIndex(1)">
            <mat-panel-title class="page-header">
              <mat-icon class="header-icon">person</mat-icon>
              Personal Details
            </mat-panel-title>
            @if( this.personalDetailsFormValid() == 'Completed'){
            <span class="status-badge completed m-4">✔ Completed</span>
            }@else if( this.personalDetailsFormValid() == 'In Progress') {
            <span class="status-badge inprogress m-4">⏳ In Progress</span>
            }@else {
            <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon> Not Started</span>
            }
          </mat-expansion-panel-header>

          <app-personal-details [formGroup]="personalDetailsForm" *ngIf="viewApplicationdetails && viewattachments"
            [personaldetails]="viewApplicationdetails" [readonly]="isReadOnly" [viewattachments]="viewattachments"
            (next)="onSectionNext($event, 1)" (preview)="previewAttachment($event)">
          </app-personal-details>

        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="this.currentStep === 2">

          <mat-expansion-panel-header class="d-flex justify-content-between" (click)="changeIndex(2)">
            <mat-panel-title class="page-header">
              <mat-icon class="header-icon">wc</mat-icon>
              Spouse Details
            </mat-panel-title>
            @if( this.spouseDetailsFormValid() == 'Completed'){
            <span class="status-badge completed m-4">✔ Completed</span>
            }@else if( this.spouseDetailsFormValid() == 'In Progress') {
            <span class="status-badge inprogress m-4">⏳ In Progress</span>
            }@else {
            <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon> Not Started</span>
            }
          </mat-expansion-panel-header>

          <app-spouse-details [formGroup]="spouseDetailsForm" *ngIf="viewApplicationdetails"
            [spousedetails]="viewApplicationdetails" [readonly]="isReadOnly" [maritalStatus]="maritalStatus"
            (next)="onSectionNext($event, 2)"></app-spouse-details>

        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="this.currentStep === 3">

          <mat-expansion-panel-header class="d-flex justify-content-between" (click)="changeIndex(3)">
            <mat-panel-title class="page-header">
              <mat-icon class="header-icon">phone</mat-icon>
              Contact Details
            </mat-panel-title>
            @if( this.contactDetailsFormValid() == 'Completed'){
            <span class="status-badge completed m-4">✔ Completed</span>
            }@else if( this.contactDetailsFormValid() == 'In Progress') {
            <span class="status-badge inprogress m-4">⏳ In Progress</span>
            }@else {
            <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon> Not Started</span>
            }
          </mat-expansion-panel-header>

          <app-contact-details [formGroup]="contactDetailsForm" *ngIf="viewApplicationdetails"
            [contactdetails]="viewApplicationdetails" [readonly]="isReadOnly"
            (next)="onSectionNext($event, 3)"></app-contact-details>

        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="this.currentStep === 4">

          <mat-expansion-panel-header class="d-flex justify-content-between" (click)="changeIndex(4)">
            <mat-panel-title class="page-header">
              <mat-icon class="header-icon">account_balance</mat-icon>
              Bank Details
            </mat-panel-title>
            @if( this.bankDetailsFormValid() == 'Completed'){
            <span class="status-badge completed m-4">✔ Completed</span>
            }@else if( this.bankDetailsFormValid() == 'In Progress') {
            <span class="status-badge inprogress m-4">⏳ In Progress</span>
            }@else {
            <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon> Not Started</span>
            }
          </mat-expansion-panel-header>

          <app-bank-details [formGroup]="bankDetailsForm" *ngIf="viewApplicationdetails && viewattachments"
            [bankdetails]="viewApplicationdetails" [readonly]="isReadOnly" [viewattachments]="viewattachments"
            (next)="onSectionNext($event, 4)" (preview)="previewAttachment($event)"></app-bank-details>

        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="this.currentStep === 5">

          <mat-expansion-panel-header class="d-flex justify-content-between" (click)="changeIndex(5)">
            <mat-panel-title class="page-header">
              <mat-icon class="header-icon">engineering</mat-icon>
              National Service Commitment
            </mat-panel-title>
            @if( this.serviceCommitmentFormValid() == 'Completed'){
            <span class="status-badge completed m-4">✔ Completed</span>
            }@else if( this.serviceCommitmentFormValid() == 'In Progress') {
            <span class="status-badge inprogress m-4">⏳ In Progress</span>
            }@else {
            <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon> Not Started</span>
            }
          </mat-expansion-panel-header>

          <app-service-commitment [formGroup]="serviceCommitment" *ngIf="viewApplicationdetails && viewattachments"
            [serviceCommitmentdetails]="viewApplicationdetails" [readonly]="isReadOnly"
            [viewattachments]="viewattachments" (next)="onSectionNext($event, 5)" (preview)="previewAttachment($event)"></app-service-commitment>

        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="this.currentStep === 6">

          <mat-expansion-panel-header class="d-flex justify-content-between" (click)="changeIndex(6)">
            <mat-panel-title class="page-header">
              <mat-icon class="header-icon">school</mat-icon>
              Academic Section
            </mat-panel-title>
            @if( this.academicFormValid() == 'Completed'){
            <span class="status-badge completed m-4">✔ Completed</span>
            }@else if( this.academicFormValid() == 'In Progress') {
            <span class="status-badge inprogress m-4">⏳ In Progress</span>
            }@else {
            <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon> Not Started</span>
            }
          </mat-expansion-panel-header>

          <app-academic-qualifications [formGroup]="academic" *ngIf="viewacdamicqualification && viewattachments"
            [academicqualifications]="viewacdamicqualification" [readonly]="isReadOnly"
            [viewattachments]="viewattachments" (next)="onSectionNext($event, 6)" (preview)="previewAttachment($event)"></app-academic-qualifications>

        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="this.currentStep === 7">

          <mat-expansion-panel-header class="d-flex justify-content-between" (click)="changeIndex(7)">
            <mat-panel-title class="page-header">
              <mat-icon class="header-icon">school</mat-icon>
              Regulatory & Professional Qualifications
            </mat-panel-title>
            @if( this.regulatoryProfessionalQualificationsFormValid() == 'Completed'){
            <span class="status-badge completed m-4">✔ Completed</span>
            }@else if( this.regulatoryProfessionalQualificationsFormValid() == 'In Progress') {
            <span class="status-badge inprogress m-4">⏳ In Progress</span>
            }@else {
            <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon> Not Started</span>
            }
          </mat-expansion-panel-header>

          <app-regulatory-professional-qualifications [formGroup]="regulatoryProfessionalQualifications"
            *ngIf="viewApplicationdetails && viewprofessionalqualification && viewattachments"
            [documentsresponse]="viewApplicationdetails" [readonly]="isReadOnly"
            [professionalqualifications]="viewprofessionalqualification" [viewattachments]="viewattachments"
            (next)="onSectionNext($event, 7)" (preview)="previewAttachment($event)"></app-regulatory-professional-qualifications>

        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="this.currentStep === 8">

          <mat-expansion-panel-header class="d-flex justify-content-between" (click)="changeIndex(8)">
            <mat-panel-title class="page-header">
              <mat-icon class="header-icon">work</mat-icon>
              Employment History
            </mat-panel-title>
            @if( this.employmentHistoryFormValid() == 'Completed'){
            <span class="status-badge completed m-4">✔ Completed</span>
            }@else if( this.employmentHistoryFormValid() == 'In Progress') {
            <span class="status-badge inprogress m-4">⏳ In Progress</span>
            }@else {
            <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon> Not Started</span>
            }
          </mat-expansion-panel-header>

          <app-employment-history [formGroup]="employmentHistory" *ngIf="viewemployementhistory"
            [employmentHistory]="viewemployementhistory" [readonly]="isReadOnly"
            (next)="onSectionNext($event, 8)"></app-employment-history>

        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="this.currentStep === 9">

          <mat-expansion-panel-header class="d-flex justify-content-between" (click)="changeIndex(9)">
            <mat-panel-title class="page-header">
              <mat-icon class="header-icon">trending_up</mat-icon>
              Business Interests & Shareholdings/Ownership
            </mat-panel-title>
            @if( this.businessInterestsFormValid() == 'Completed'){
            <span class="status-badge completed m-4">✔ Completed</span>
            }@else if( this.businessInterestsFormValid() == 'In Progress') {
            <span class="status-badge inprogress m-4">⏳ In Progress</span>
            }@else {
            <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon> Not Started</span>
            }
          </mat-expansion-panel-header>

          <app-business-interests [formGroup]="businessInterests" *ngIf="viewbusinessintersts && viewattachments"
            [businessInterests]="viewbusinessintersts" [readonly]="isReadOnly" [viewattachments]="viewattachments"
            (next)="onSectionNext($event, 9)" (preview)="previewAttachment($event)"></app-business-interests>

        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="this.currentStep === 10">

          <mat-expansion-panel-header class="d-flex justify-content-between" (click)="changeIndex(10)">
            <mat-panel-title class="page-header">
              <mat-icon class="header-icon">info</mat-icon>
              General Information
            </mat-panel-title>
            @if( this.generalInformationFormValid() == 'Completed'){
            <span class="status-badge completed m-4">✔ Completed</span>
            }@else if( this.generalInformationFormValid() == 'In Progress') {
            <span class="status-badge inprogress m-4">⏳ In Progress</span>
            }@else {
            <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon>Not Started</span>
            }
          </mat-expansion-panel-header>

          <app-general-information [formGroup]="generalInformation" *ngIf="viewgeneralinformation && viewattachments"
            [generalInformation]="viewgeneralinformation" [readonly]="isReadOnly" [viewattachments]="viewattachments"
            (next)="onSectionNext($event, 10)" (preview)="previewAttachment($event)"></app-general-information>

        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="this.currentStep === 11">

          <mat-expansion-panel-header class="d-flex justify-content-between" (click)="changeIndex(11)">
            <mat-panel-title class="page-header">
              <mat-icon class="header-icon">verified_user</mat-icon>
              Fit and Proper Criteria
            </mat-panel-title>
            @if( this.fitandProperCriteriaFormValid() == 'Completed'){
            <span class="status-badge completed m-4">✔ Completed</span>
            }@else if( this.fitandProperCriteriaFormValid() == 'In Progress') {
            <span class="status-badge inprogress m-4">⏳ In Progress</span>
            }@else {
            <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon> Not Started</span>
            }
          </mat-expansion-panel-header>

          <app-fit-propercriteria [formGroup]="fitandProperCriteria"
            *ngIf="viewfitpropercriteria && viewattachments && viewApplicationdetails"
            [bscgrade]="viewApplicationdetails" [fitandProperCriteria]="viewfitpropercriteria" [readonly]="isReadOnly"
            [viewattachments]="viewattachments" (next)="onSectionNext($event, 11)" (preview)="previewAttachment($event)"></app-fit-propercriteria>

        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="this.currentStep === 12">

          <mat-expansion-panel-header class="d-flex justify-content-between" (click)="changeIndex(12)">
            <mat-panel-title class="page-header">
              <mat-icon class="header-icon">add_box</mat-icon>
              Additional Declarations
            </mat-panel-title>
            @if( this.additionalDeclarationsFormValid() == 'Completed'){
            <span class="status-badge completed m-4">✔ Completed</span>
            }@else if( this.additionalDeclarationsFormValid() == 'In Progress') {
            <span class="status-badge inprogress m-4">⏳ In Progress</span>
            }@else {
            <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon> Not Started</span>
            }
          </mat-expansion-panel-header>

          <app-additional-declarations [formGroup]="additionalDeclarations" *ngIf="viewApplicationdetails"
            [additionalDeclarations]="viewApplicationdetails" [readonly]="isReadOnly"
            (next)="onSectionNext($event, 12)"></app-additional-declarations>

        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="this.currentStep === 13">

          <mat-expansion-panel-header class="d-flex justify-content-between" (click)="changeIndex(13)">
            <mat-panel-title class="page-header">
              <mat-icon class="header-icon">attach_file</mat-icon>
              Additional Attachments
            </mat-panel-title>
            @if( this.additionalAttachmentsFormValid() == 'Completed'){
            <span class="status-badge completed m-4">✔ Completed</span>
            }@else if( this.additionalAttachmentsFormValid() == 'In Progress') {
            <span class="status-badge inprogress m-4">⏳ In Progress</span>
            }@else {
            <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon> Not Started</span>
            }
          </mat-expansion-panel-header>

          <app-additional-attachments [formGroup]="additionalAttachments" [viewattachments]="viewattachments"
            *ngIf="viewattachments" [readonly]="isReadOnly" [viewId]="viewId" (next)="onSectionNext($event, 13)" (preview)="previewAttachment($event)"></app-additional-attachments>

        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="this.currentStep === 14">

          <mat-expansion-panel-header class="d-flex justify-content-between" (click)="changeIndex(14)">
            <mat-panel-title class="page-header">
              <mat-icon class="header-icon">how_to_reg</mat-icon>
              Declaration Clauses
            </mat-panel-title>
            @if( this.declarationClausesFormValid() == 'Completed'){
            <span class="status-badge completed m-4">✔ Completed</span>
            }@else if( this.declarationClausesFormValid() == 'In Progress') {
            <span class="status-badge inprogress m-4">⏳ In Progress</span>
            }@else {
            <span class="status-badge notstarted m-4"><mat-icon>play_arrow</mat-icon> Not Started</span>
            }
          </mat-expansion-panel-header>

          <app-declaration-clauses [formGroup]="declarationClauses" [message]="submitmessage"
            *ngIf="viewApplicationdetails" [readonly]="isReadOnly" [declarationClauses]="viewApplicationdetails"
            (next)="onSectionNext($event, 14)"></app-declaration-clauses>

        </mat-expansion-panel>
        <!-- <mat-expansion-panel [expanded]="this.currentStep === 14">

         <mat-expansion-panel-header class="d-flex justify-content-between">
          <mat-panel-title class="page-header">
            <mat-icon class="header-icon">assignment_turned_in</mat-icon>
            Acknowledgement
            @if( this.acknowledgementFormFormValid() == 'Completed'){
            <span class="status-badge completed">✔ Completed</span>
            }@else {
            <span></span>
            }
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-acknowledgement-form [formGroup]="acknowledgementForm"
          (submitForm)="onSubmit()"></app-acknowledgement-form>
      </mat-expansion-panel> -->


      </mat-accordion>
    </div>
  </div>
  @if (showPreview) {
  <div class="preview-backdrop" appDocumentPreviewOverlay (dismiss)="closePreview()">

    <div class="preview-panel" role="dialog" aria-modal="true" aria-label="Document preview">

      <!-- Header -->
      <div class="preview-header d-flex justify-content-between align-items-center p-3 border-bottom">
        <div class="d-flex flex-column">
          <span class="fw-bold fs-5">Document Preview</span>
          <small class="text-muted">{{ currentFileName }}</small>
        </div>
        <div class="preview-header-actions">
          @if (!isPdf) {
          <button mat-icon-button (click)="zoomOut()" [disabled]="zoomLevel <= MIN_ZOOM" title="Zoom out">
            <mat-icon>zoom_out</mat-icon>
          </button>
          <span class="zoom-level">{{ zoomLevel * 100 }}%</span>
          <button mat-icon-button (click)="zoomIn()" [disabled]="zoomLevel >= MAX_ZOOM" title="Zoom in">
            <mat-icon>zoom_in</mat-icon>
          </button>
          }
          <button mat-icon-button color="warn" (click)="closePreview()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <!-- Preview Content -->
      <div class="preview-content">
        @if (isPdf) {
        <!-- <embed [src]="selectedDocument"  width="100%" height="600px" /> -->
        <iframe [src]="selectedDocument" class="preview-pdf"></iframe>

        } @else {
        <img [src]="selectedDocument" alt="Document Preview" class="preview-image"
          [style.transform]="'scale(' + zoomLevel + ')'" />
        }
      </div>

    </div>
  </div>
  }
</div>
<!-- </app-pias-layout> -->
